import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=3bb8ad66&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./orderList.vue?vue&type=style&index=1&id=3bb8ad66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb8ad66",
  null
  
)

export default component.exports